import { IDocument } from '@common/models/Document/IDocument';
import { formatMarkdownTableCell } from '@app/utils';
import { EXCEL_FILE_FORMATS } from '@common/constants';

export function convertDataDictionaryToMarkdown(
    documentModel: IDocument
): string {
    let data = documentModel.dataDictionary;
    const tableNames = Object.keys(data);
    let markdown = '';
    let tableMap = documentModel.documentMetaData ? getMappingOfSheetAndTableNames(documentModel) : {};

    tableNames.forEach((table) => {
        if (data[table][0].trim() !== '') {
            const tableData = data[table][0];
            const parsedData = JSON.parse(
                tableData.replace(/```json\n|\n```/g, '')
            );
            const rows = Object.entries(parsedData);
            if (EXCEL_FILE_FORMATS.includes(documentModel?.contentType)) {
                markdown += `#### ${table}`;
                if(table in tableMap) {
                    markdown += ` (${tableMap[table]})`
                }
                markdown += '\n'
            }
            markdown += `| Column | Description |\n`;
            markdown += `| --- | ----- |\n`;
            rows.forEach(([key, value]) => {
                markdown += `| ${key} | ${formatMarkdownTableCell(value)} |\n`;
            });
        }
        markdown += '\n';
    });

    return markdown;
}

function getMappingOfSheetAndTableNames(documentModel: IDocument) {
    const allTables = Object.values(documentModel.documentMetaData).flat() as {
        tableName: string;
        sheetName: string;
    }[];

    const tableMapping = {};

    for(let table of allTables) {
        tableMapping[table.tableName] = table.sheetName;
    }

    return tableMapping;
}
